var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 18,
    viewBox: "0 0 50 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.354 8.87118C33.354 4.58424 36.8416 1.09658 41.1286 1.09658V1H6.79474C3.5944 1 1 3.5944 1 6.79474V10.9476C1 14.148 3.5944 16.7424 6.79474 16.7424H41.1286V16.6458C36.8416 16.6458 33.354 13.1581 33.354 8.87118Z",
    fill: "#FFF0AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.7539 13.3145H1.50488C2.41002 15.335 4.4375 16.743 6.7948 16.743H41.1286V16.6464C38.4927 16.6464 36.1605 15.3267 34.7539 13.3145Z",
    fill: "#FFE177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.129 16.7424C45.4761 16.7424 49.0002 13.2183 49.0002 8.87118C49.0002 4.52405 45.4761 1 41.129 1C36.7819 1 33.2578 4.52405 33.2578 8.87118C33.2578 13.2183 36.7819 16.7424 41.129 16.7424Z",
    fill: "#FFC344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.7085 1.8623C45.2763 2.97034 45.5718 4.19774 45.5706 5.44278C45.5706 9.78989 42.0466 13.314 37.6995 13.314H34.6309C36.0489 15.3838 38.4295 16.7425 41.128 16.7425C45.4751 16.7425 48.9992 13.2184 48.9992 8.87133C48.9992 5.81403 47.255 3.16583 44.7085 1.8623Z",
    fill: "#F6AB31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.5577 12.1065H39.0855C38.8384 12.1065 38.6014 12.0084 38.4267 11.8336C38.252 11.6589 38.1538 11.4219 38.1538 11.1748V8.65924C38.1538 8.41214 38.252 8.17515 38.4267 8.00043C38.6014 7.8257 38.8384 7.72754 39.0855 7.72754H43.5577C43.8048 7.72754 44.0418 7.8257 44.2165 8.00043C44.3912 8.17515 44.4894 8.41214 44.4894 8.65924V11.1748C44.4894 11.4219 44.3912 11.6589 44.2165 11.8336C44.0418 12.0084 43.8048 12.1065 43.5577 12.1065Z",
    fill: "#FFF0AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.5577 7.72754H42.4612V9.15063C42.4612 9.39773 42.3631 9.63471 42.1883 9.80944C42.0136 9.98417 41.7766 10.0823 41.5295 10.0823H38.1538V11.1748C38.1538 11.4219 38.252 11.6589 38.4267 11.8336C38.6014 12.0084 38.8384 12.1065 39.0855 12.1065H43.5577C43.8048 12.1065 44.0418 12.0084 44.2165 11.8336C44.3912 11.6589 44.4894 11.4219 44.4894 11.1748V8.65924C44.4894 8.41214 44.3912 8.17515 44.2165 8.00043C44.0418 7.8257 43.8048 7.72754 43.5577 7.72754Z",
    fill: "#FFE177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.0585 11.2861V6.46609L29.3173 11.1849C29.3777 11.2722 29.4424 11.2295 29.4424 11.1233L29.3972 6.45711M23.644 6.45711V11.2861M20.4952 6.8695C20.0966 6.59999 19.6263 6.45632 19.1452 6.45711C17.8117 6.45711 16.7307 7.53811 16.7307 8.87158C16.7307 10.205 17.8117 11.2861 19.1452 11.2861C20.4786 11.2861 21.2294 10.205 21.2294 8.87158H19.7849M6.0708 6.45711V11.282C6.12421 11.2912 7.76171 11.282 7.76171 11.282M41.3215 4.1875C40.2924 4.1875 39.4581 5.02175 39.4581 6.0509V7.72799H43.1849V6.0509C43.1849 5.02175 42.3507 4.1875 41.3215 4.1875Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.1078 11.285C13.4413 11.285 14.5223 10.204 14.5223 8.87053C14.5223 7.53705 13.4413 6.45605 12.1078 6.45605C10.7744 6.45605 9.69336 7.53705 9.69336 8.87053C9.69336 10.204 10.7744 11.285 12.1078 11.285Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M41.1286 1H15.1488M29.3459 16.7424H41.1286M11.7686 1H6.79474C3.5944 1 1 3.5944 1 6.79474V10.9476C1 14.148 3.5944 16.7424 6.79474 16.7424H25.9657M43.5578 12.1066H39.0856C38.8385 12.1066 38.6015 12.0084 38.4268 11.8337C38.2521 11.659 38.1539 11.422 38.1539 11.1749V8.65929C38.1539 8.41219 38.2521 8.17521 38.4268 8.00048C38.6015 7.82575 38.8385 7.72759 39.0856 7.72759H43.5578C43.8049 7.72759 44.0419 7.82575 44.2166 8.00048C44.3913 8.17521 44.4895 8.41219 44.4895 8.65929V11.1749C44.4895 11.422 44.3913 11.659 44.2166 11.8337C44.0419 12.0084 43.8049 12.1066 43.5578 12.1066Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.651 6.41451C33.3903 7.20733 33.2576 8.03661 33.2578 8.87118C33.2578 13.2183 36.7819 16.7424 41.129 16.7424C45.4761 16.7424 49.0002 13.2183 49.0002 8.87118C49.0002 4.52407 45.4761 1 41.129 1C38.8568 1 36.8108 1.96405 35.374 3.50391",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBonus);
export default __webpack_public_path__ + "static/media/login_bonus.52b4d140b16a0b05617dfd24664ef70c.svg";
export { ForwardRef as ReactComponent };